'use strict';

module.exports = {
  BRAINTREE_API_VERSION_HEADER: '2017-04-03'
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/client/constants.js
// module id = 781
// module chunks = 0